module.exports = __webpack_public_path__ + "static/media/SMARTMART.cccb9e08.png";